export default {"src":"/_next/static/media/Icon-Administration.66b120a5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};